import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfilEsnComponent } from './components/profil-esn/profil-esn.component';
import { MyReviewsComponent } from './components/my-reviews/my-reviews.component';
import { EditProfileEsnComponent } from './components/edit-profile-esn/edit-profile-esn.component';

const routes: Routes = [

  {
    path:'details-profil',
    component:ProfilEsnComponent,
  },
  {
    path:'my-reviews',
    component:MyReviewsComponent,
  },
  {
    path:'modifier-profil',
    component:EditProfileEsnComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DetailsProfilRoutingModule { }
